import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "axios";
import api from "../../components/commonComponents/axiosSetup";
import { BASE_URL } from "../../config";


export const fetchPlans = createAsyncThunk(
  'planManagement/fetchplans',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`${BASE_URL}apis/plans`);
      console.log(response)
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch Plans');
    }
  }
);

export const createPlan = createAsyncThunk(
  'planManagement/createPlan', 
  async (planData, thunkAPI) => {
    try {
      const response = await api.post(
        `${BASE_URL}apis/plans`,
        planData
      );
      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchPlans());
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to create'
      );
    }
  }
);


export const updatePlan = createAsyncThunk(
  'planManagement/updatePlan', 
  async ({ id, planData }, thunkAPI) => {
    try {
      const response = await api.put(`${BASE_URL}apis/plans/${id}`,
        planData

      );

      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchPlans());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to Update Plan'
      );
    }
  }
);

export const updatePlanState = createAsyncThunk(
  'planManagement/updatePlanState', 
  async ({ id, planState }, thunkAPI) => {
    try {
      const response = await api.patch(`${BASE_URL}apis/plans/${id}/status`,
        { status: planState }
        
      );

      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchPlans());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to Update Plan'
      );
    }
  }
);

export const assignPlanToAccount = createAsyncThunk(
  'planManagement/assignPlanToAccount', 
  async ({ id, accountNames }, thunkAPI) => {
    try {
      const response = await api.put(`${BASE_URL}apis/plans/${id}/assign`,
        {accountNames: accountNames}
        
      );

      // Re-fetch list after successful creation
      thunkAPI.dispatch(fetchPlans());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || 'Failed to Update Plan'
      );
    }
  }
);


// export const deletePlan = createAsyncThunk(
//   'planManagement/deletePlan',
//   async (planId, thunkAPI) => {
//     try {
//       await axios.delete(`http://localhostapi/companyId=13/plans/delete?&planId=${planId}`);

//       // Refresh account list after deletion
//       thunkAPI.dispatch(fetchPlans());

//       return accountId;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete Plan');
//     }
//   }
// );